import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { mutate } from "lib/graphql/mutate"

export const updateDraftLegacyScheduleGroups = api(async function updateDraftLegacyScheduleGroups({
    projectId,
    scheduleId,
    legacyScheduleGroups,
}) {
    return mutate(
        gql`
            mutation UpdateDraftLegacyScheduleGroups(
                $projectId: String!
                $scheduleId: String!
                $legacyScheduleGroups: [Int!]!
            ) {
                updateDraftLegacyScheduleGroups(
                    projectId: $projectId
                    scheduleId: $scheduleId
                    legacyScheduleGroups: $legacyScheduleGroups
                )
            }
        `,
        { projectId, scheduleId, legacyScheduleGroups },
        { returns: "updateDraftLegacyScheduleGroups" }
    )
})
